var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayCommercialRelation)?_c('span',{staticClass:"badge",style:(`background-color:${_vm.displayCommercialRelation.color}; max-width: fit-content;`)},[_vm._v(" "+_vm._s(_vm.displayCommercialRelation.pseudo)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }